import { Link } from 'react-router-dom'
import { ChevronDown } from 'lucide-react'
import { navItems } from './navItems'

export const DesktopNav = ({
  activeMainNav,
  getActiveSubNav
}: {
  activeMainNav: string | null
  getActiveSubNav: () => { href: string; title: string }[]
}) => {
  return (
    <nav className="bg-wine-100 hidden lg:block">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center">
          <ul className="flex space-x-8 list-none">
            {navItems.map((item, i) => (
              <li key={i}>
                <Link
                  to={item.href}
                  className={`flex items-center text-sm px-3 py-4 font-satoshi ${
                    activeMainNav === item.title
                      ? 'text-white font-bold'
                      : 'text-white font-medium'
                  }`}
                >
                  {item.title}

                  {item.hasDropdown &&
                    activeMainNav === item.title &&
                    getActiveSubNav().length > 0 && (
                      <ChevronDown className="ml-1 w-4 h-4" />
                    )}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  )
}